import React from 'react';
import i18n from 'i18next';
import Question from 'src/components/survey/surveyQuestion';
import Modal from 'src/modules/shared/modal/components/modal';
import { trackFootfallEvent } from 'src/utils/analytics';
import footfallEventTypes from 'src/constants/footfallEventTypes';

class SorryToSeeYouGoModal extends React.Component {
  state = {
    age: null,
  };
  render() {
    const { onClose, onCancel } = this.props;
    return (
      <Modal
        noClose={true}
      >
        <div className="signup-box__terms">
          <h3 className="signup-box__questions__title">{i18n.t('Sorry to see you go')}</h3>
          <p>Please take a moment to let us know why you are leaving.</p>
          <Question
            options={[{ label: 'I am under 16 years old', value: 'under16' }, { label: 'Other', value: 'other' }]}
            value={this.state.age}
            onSelected={value => this.setState({ age: value })}
          />
          <p>
            <textarea
              className="form-control"
              placeholder="If 'Other', please explain"
              ref={node => (this.reason = node)}
            />
          </p>
          <p>
            <a
              href="#"
              onClick={e => {
                e.preventDefault();
                onClose();
              }}
            >
              {i18n.t("I've changed my mind, take me back!")}
            </a>
          </p>
          <p>
            <button
              className="btn btn-primary"
              onClick={() => {
                onCancel({
                  reason: this.state.age,
                  reasonText: this.reason.value,
                });
                trackFootfallEvent(footfallEventTypes.CLICKED, {
                  clickType: 'join-cancel',
                  clickMetadata: {
                    reason: this.state.age,
                    reasonText: this.reason.value,
                  },
                });
              }}
            >
              Cancel
            </button>
          </p>
        </div>
      </Modal>
    );
  }
}

export default SorryToSeeYouGoModal;



// WEBPACK FOOTER //
// ./src/modules/shared/modal/components/signup/sorryToSeeYouGoModal.js